import axios from '../../axiosConfig'
import { tokenConfig } from '../auth'
import {
  FETCH_MAS_PERFILES,
  FETCH_PERFILES,
  GET_MAS_PERFILES,
  GET_PERFILES,
  SET_BUSQUEDA_PERFIL,
  SET_PERFIL_SELECCIONADO,
  UNSET_PERFIL_SELECCIONADO,
} from '../types'

// GET P PERFILES
export const getPerfiles =
  (grupo_perfil = '', codigo_serie = '', codigo_subserie = '', search = '', paginar = 'N') =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_PERFILES,
    })

    let config = tokenConfig(getState)

    if (grupo_perfil == null || grupo_perfil == 'null') grupo_perfil = ''
    if (codigo_serie == null || codigo_serie == 'null') codigo_serie = ''
    if (codigo_subserie == null || codigo_subserie == 'null') codigo_subserie = ''

    axios
      .get(
        `/perfiles/?grupo_perfil=${grupo_perfil}&codigo_serie=${codigo_serie}&codigo_subserie=${codigo_subserie}&search=${search}&paginar=${paginar}`,
        config,
      )
      .then(res => {
        dispatch({
          type: GET_PERFILES,
          payload: res.data,
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

// GET MÁS PERFILES
export const getMasPerfiles =
  (url, grupo_perfil, codigo_serie, codigo_subserie, limit = 15) =>
  (dispatch, getState) => {
    dispatch({
      type: FETCH_MAS_PERFILES,
    })

    if (grupo_perfil == null || grupo_perfil == 'null') grupo_perfil = ''
    if (codigo_serie == null || codigo_serie == 'null') codigo_serie = ''
    if (codigo_subserie == null || codigo_subserie == 'null') codigo_subserie = ''

    if (url == null || url === '') {
      url = `/perfiles/?grupo_perfil=${grupo_perfil}&codigo_serie=${codigo_serie}&codigo_subserie=${codigo_subserie}&search=&paginar=S&limit=${limit}`
    } else {
      if (url.startsWith('http://')) {
        url = url.replace('http://', 'https://')
      }
    }

    axios
      .get(url, tokenConfig(getState))
      .then(res => {
        dispatch({
          type: GET_MAS_PERFILES,
          payload: res.data,
        })
      })
      .catch(err => console.log(err))
  }

export const setBusquedaPerfil = search => (dispatch, getState) => {
  dispatch({
    type: SET_BUSQUEDA_PERFIL,
    payload: search,
  })
}

export const setPerfilSeleccionado = (codigo, nombre) => (dispatch, getState) => {
  dispatch({
    type: SET_PERFIL_SELECCIONADO,
    payload: codigo,
  })
}

export const unsetPerfilSeleccionado = () => (dispatch, getState) => {
  dispatch({
    type: UNSET_PERFIL_SELECCIONADO,
  })
}
